require.register("thesaurus/controllers/confirmModalCtrl", function(exports, require, module){
  $0
  
});

